import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-caidan_shujufenxi",
  "use": "icon-icon-caidan_shujufenxi-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-icon-caidan_shujufenxi\">\r\n<style type=\"text/css\">\r\n\t#icon-icon-caidan_shujufenxi .st0{fill:#333333;}\r\n</style>\r\n<g>\r\n\t<path class=\"st0\" d=\"M26,3H6C4.3,3,3,4.3,3,6v20c0,1.7,1.3,3,3,3h20c1.7,0,3-1.3,3-3V6C29,4.3,27.7,3,26,3z M27,26c0,0.6-0.4,1-1,1\r\n\t\tH6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h20c0.6,0,1,0.4,1,1V26z\" />\r\n\t<path class=\"st0\" d=\"M10,15c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1s1-0.4,1-1v-7C11,15.4,10.6,15,10,15z\" />\r\n\t<path class=\"st0\" d=\"M16,10c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1s1-0.4,1-1V11C17,10.4,16.6,10,16,10z\" />\r\n\t<path class=\"st0\" d=\"M22,13c-0.6,0-1,0.4-1,1v9c0,0.6,0.4,1,1,1s1-0.4,1-1v-9C23,13.4,22.6,13,22,13z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-caidan_shujufenxi.svg
// module id = HOwq
// module chunks = 95